import {
    TableContainer,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    VStack,
    HStack,
    Box,
    Text,
    Badge,
} from '@chakra-ui/react';
import useIsMobile from '../hooks/useIsMobile.js';
import { unitSelector } from '../helpers/unitSelector.js';
import { parameterTextConverter } from '../helpers/parameterTextConverter.js';
import { STATUS_COLOR_SCHEME } from '../constants/status.js';

const DataComposer = ({ data }) => {

    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <VStack spacing={3} align='stretch'>
                {data.map((sensor, i) =>
                    <Box key={sensor.tableRow.parameter ?? i} borderRadius='md' bg='white' p={3} shadow='sm'>
                        <HStack justify='space-between' mb={1}>
                            <Text fontWeight='bold' fontSize='sm'>
                                {parameterTextConverter(sensor.tableRow.parameter)}
                            </Text>
                            <Badge
                                colorScheme={STATUS_COLOR_SCHEME[sensor.tableRow.statuscode] ?? 'gray'}
                                fontSize='xs'
                            >
                                {sensor.tableRow.status}
                            </Badge>
                        </HStack>
                        <Text fontSize='xl' fontWeight='bold' color='gray.700'>
                            {sensor.tableRow.value}{' '}
                            <Text as='span' fontSize='sm' fontWeight='normal'>
                                {unitSelector(sensor.tableRow.parameter)}
                            </Text>
                        </Text>
                        <Text fontSize='xs' color='gray.500' mt={1}>
                            {sensor.tableRow.datetime}
                        </Text>
                    </Box>
                )}
            </VStack>
        );
    }

    return (
        <TableContainer overflowX='auto' w='full'>
            <Table size='sm' variant='striped' colorScheme='facebook' w='full'>
                <Thead>
                    <Tr>
                        <Th>Parámetro</Th>
                        <Th>Fecha</Th>
                        <Th>Estado</Th>
                        <Th>Valor</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {data.map((sensor, i) =>
                        <Tr key={sensor.tableRow.parameter ?? i}>
                            <Td fontSize='sm'>{parameterTextConverter(sensor.tableRow.parameter)}</Td>
                            <Td fontSize='sm' color='gray.600'>{sensor.tableRow.datetime}</Td>
                            <Td fontSize='sm'>
                                <Badge colorScheme={STATUS_COLOR_SCHEME[sensor.tableRow.statuscode] ?? 'gray'}>
                                    {sensor.tableRow.status}
                                </Badge>
                            </Td>
                            <Td fontSize='sm' color='gray.600'>{sensor.tableRow.value} {unitSelector(sensor.tableRow.parameter)}</Td>
                        </Tr>
                    )}
                </Tbody>
            </Table>
        </TableContainer>
    );
};

export default DataComposer;
